export default __webpack_public_path__ + "static/media/lawman.8eeacc26.png";